<template>
  <PzToastContainer
    ref="toastContainer"
    position="top-right"
    :max-toasts="5"
  />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import PzToastContainer from '@/components/ui-components/PzToastContainer.vue';
import useSnackbar from './composables';

const toastContainer = ref(null);
const { setToastContainer } = useSnackbar();

onMounted(() => {
  // Register this container with the composable
  setToastContainer(toastContainer.value);
});
</script>
